import { SupabaseClientService } from 'src/services';
import {
  CreateCrmSalesTicketPayload,
  UpdateCrmSalesTicketData
} from './types';

export const fetchCrmSalesTickets = (
  status?: string,
  options?: {
    search_customer?: string;
    sort_by?: string;
    start_date?: string;
    end_date?: string;
    limit?: number;
    offset?: number;
  }
) => {
  let query = SupabaseClientService.from('crm_sales_tickets').select('*');

  // filter by status
  if (status) {
    query = query.eq('status', status);
  }

  // search by customer name
  if (options?.search_customer) {
    query = query.ilike('customer_name', `%${options?.search_customer}%`);
  }

  // date range filter
  if (options?.start_date) {
    query = query.gte('created_at', options?.start_date);
  }

  if (options?.end_date) {
    query = query.lte('created_at', options?.end_date);
  }

  // sorting
  if (options?.sort_by) {
    const [field, direction] = options?.sort_by?.split(':');
    query = query.order(field, { ascending: direction === 'asc' });
  } else {
    query = query.order('created_at', { ascending: false });
  }

  // pagination
  if (options?.limit && options.offset !== undefined) {
    query = query.range(
      options.offset,
      options.offset + (options.limit ?? 10) - 1
    );
  } else if (options?.limit) {
    query = query.limit(options.limit);
  }

  return query;
};

export const addCrmSalesTicket = (payload: CreateCrmSalesTicketPayload) => {
  return SupabaseClientService.from('crm_sales_tickets').insert(payload);
};

export const updateCrmSalesTicket = (
  id: number,
  payload: UpdateCrmSalesTicketData
) => {
  return SupabaseClientService.from('crm_sales_tickets')
    .update(payload)
    .eq('id', id);
};
